import React, { ReactElement } from 'react';
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import {WithTranslation, withTranslation} from 'react-i18next';

interface ConfirmationModalProps extends WithTranslation {
  toggle: () => void;
  isOpen: boolean;
  title: string;
  content: string | ReactElement<any>;
  onConfirm: () => void;
  onCancel: () => void;
}

class ConfirmationModal extends React.PureComponent<ConfirmationModalProps> {

  render() {
      const { t } = this.props;

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} autoFocus={false}>
        <ModalHeader toggle={this.props.toggle}>{ this.props.title }</ModalHeader>
        <ModalBody>
          { this.props.content }
        </ModalBody>
        <ModalFooter>
          <Button className="mt-r btn btn-outline-secondary" color="secondary" onClick={this.props.onCancel}>{t('b.cancel_Generic cancel button translation').toUpperCase()}</Button>
          <Button color="primary" onClick={this.props.onConfirm}>{t('b.confirm').toUpperCase()}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslation()(ConfirmationModal);
